import GlobalNavBar from './GlobalNavBar'

export default GlobalNavBar
